import { faClock, faMapMarkerAlt, faTags } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { capitalizeFirstLetter, truncateText } from '../../utils/formatText';

export default function ProgramList({ listEvents, onOpenModal }) {
    return (
        <div className="program__list">
            {listEvents.length === 0 ? (
                <div className="program__empty">Ingen aktiviteter denne dagen.</div>
            ) : (
                listEvents.map(ev => (
                    <div
                        key={ev.id}
                        className={`program__list-item program__list-item--${ev.categoryKey}`}
                        onClick={() => onOpenModal(ev)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') onOpenModal(ev);
                        }}
                    >
                        <div className="program__list-title">{ev.title}</div>

                        <div className="program__list-meta">
                            <div className="program__list-meta-item">
                                <FontAwesomeIcon icon={faClock} size="sm" />
                                {ev.startTime}–{ev.endTime}
                            </div>

                            {ev.location && (
                                <div className="program__list-meta-item">
                                    <FontAwesomeIcon icon={faMapMarkerAlt} size="sm" />
                                    {ev.location}
                                </div>
                            )}

                            <div className="program__list-meta-item">
                                <FontAwesomeIcon icon={faTags} size="sm" />
                                {capitalizeFirstLetter(ev.type_navn)}
                            </div>
                        </div>

                        {ev.description && (
                            <div
                                className="program__event-description-excerpt"
                                dangerouslySetInnerHTML={{
                                    __html: truncateText(ev.description, 90)
                                }}
                            ></div>
                        )}
                    </div>
                ))
            )}
        </div>
    );
}
